import { render, staticRenderFns } from "./CrudResponsibility.vue?vue&type=template&id=11feecfb&"
import script from "./CrudResponsibility.vue?vue&type=script&lang=js&"
export * from "./CrudResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports